/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {OfferSearchResponsePagination} from './OfferSearchResponsePagination';
import {Offers} from './Offers';

/**
 * The OfferSearchResponse model module.
 * @module model/OfferSearchResponse
 * @version v1
 */
export class OfferSearchResponse {
  /**
   * Constructs a new <code>OfferSearchResponse</code>.
   * @alias module:model/OfferSearchResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>OfferSearchResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/OfferSearchResponse} obj Optional instance to populate.
   * @return {module:model/OfferSearchResponse} The populated <code>OfferSearchResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new OfferSearchResponse();
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('offers'))
        obj.offers = Offers.constructFromObject(data['offers']);
      if (data.hasOwnProperty('pagination'))
        obj.pagination = OfferSearchResponsePagination.constructFromObject(data['pagination']);
    }
    return obj;
  }
}

/**
 * @member {String} status
 */
OfferSearchResponse.prototype.status = undefined;

/**
 * @member {module:model/Offers} offers
 */
OfferSearchResponse.prototype.offers = undefined;

/**
 * @member {module:model/OfferSearchResponsePagination} pagination
 */
OfferSearchResponse.prototype.pagination = undefined;

